import { Form } from '@ant-design/compatible';
import React from 'react';

import { PhoneNumberField } from '../../components/PhoneNumberField';
import { FORM_ITEM_DEFAULT_LAYOUT } from '../../pages/ModelForm/form-fields';
import { IModelFormFieldOptions } from '../typings';

import model from './model';
import PropertyFeatureFlags from './PropertyFeatureFlags';

interface ICreatePhoneNumberFormFieldArgs extends IModelFormFieldOptions<any> {
  fieldName: string;
  helpText?: string;
}

function createPhoneNumberFormField(
  args: ICreatePhoneNumberFormFieldArgs,
): IModelFormFieldOptions<any> {
  const { helpText, ...formFieldOptions } = args;

  return {
    maxLength: 20,
    render: ({ FormItem, formItemProps, formikProps, field, disabled }) => {
      const { values, setFieldValue } = formikProps;

      return (
        <FormItem {...formItemProps}>
          <PhoneNumberField
            value={values[field.name]}
            onChange={(value) => setFieldValue(field.name, value)}
            disabled={disabled || formikProps.isSubmitting}
          />
          {helpText && <p className='help-text'>{helpText}</p>}
        </FormItem>
      );
    },
    ...formFieldOptions,
  };
}

const formFields = model.createFormFields([
  createPhoneNumberFormField({ fieldName: 'supportPhoneNumber' }),
  {
    fieldName: 'name',
    maxLength: 100,
  },
  {
    fieldName: 'supportEmail',
    maxLength: 320,
  },
  {
    fieldName: 'address',
    maxLength: 300,
  },
  {
    fieldName: 'virtualDirectoryPhoneNumber',
    hidden: () => true, // @TODO: Deprecated field
  },
  {
    fieldName: 'virtualDirectoryStaffHours',
    hidden: () => true, // @TODO: Deprecated field
  },
]);

model.setFormOptions({
  fields: formFields,
  renderExtra: (formikProps, isNew) => {
    if (isNew) {
      return null;
    }

    return (
      <Form.Item
        {...FORM_ITEM_DEFAULT_LAYOUT}
        label='Feature Flags'
      >
        <PropertyFeatureFlags property={formikProps.values} />
      </Form.Item>
    );
  },
});
